import { LOGOUT_SUCCESS } from "../Types";
import { CALL_API } from "../api.middleware";
import {
	GET_WORKSHOP_SEGMENTS,
	GET_WORKSHOP_SEGMENTS_FAILED,
	GET_WORKSHOP_SEGMENTS_SUCCESS,
	GET_VEHICLE_PERSPECTIVES,
	GET_VEHICLE_PERSPECTIVES_SUCCESS,
	GET_VEHICLE_PERSPECTIVES_FAILED,
	GET_DAMAGE_TYPES,
	GET_DAMAGE_TYPES_SUCCESS,
	GET_DAMAGE_TYPES_FAILED,
	GET_BODY_DAMAGE_TYPES,
	GET_BODY_DAMAGE_TYPES_SUCCESS,
	GET_BODY_DAMAGE_TYPES_FAILED,
	CLEAR_DAMAGE_TYPES,
	CLEAR_BODY_DAMAGE_TYPES_SUCCESS,
	SAVE_SELECTED_PART_ID,
	SAVE_ORIENTATION,
	GET_GLOBAL_SETTINGS,
	GET_GLOBAL_SETTINGS_SUCCESS,
	GET_GLOBAL_SETTINGS_FAILED,
	GET_LIST_OF_WORKSHOPS,
	GET_LIST_OF_WORKSHOPS_SUCCESS,
	GET_LIST_OF_WORKSHOPS_FAILED,
	GET_WORKSHOP_DISTANCE,
	GET_WORKSHOPS_DISTANCE_SUCCESS,
	GET_WORKSHOPS_DISTANCE_FAILED,
} from "../Types/workshop";
import { CLIENT_NAME } from "../../constants";

export const workshopTemplate = () => async (dispatch) => {
	try {
		return await dispatch({
			[CALL_API]: {
				url: `/catalog/workshop-segments?clientName=${CLIENT_NAME}`,
				method: "GET",
				types: [
					GET_WORKSHOP_SEGMENTS,
					GET_WORKSHOP_SEGMENTS_SUCCESS,
					GET_WORKSHOP_SEGMENTS_FAILED,
				],
				showLoader: true,
				showToast: true,
			},
		});
	} catch (error) {
		// alert("W43 = " + `${error}`);
		console.error("WShop - 44", error);
	}
};

export const getVehiclePerspectives =
	(params = {}) =>
	async (dispatch) => {
		try {
			return await dispatch({
				[CALL_API]: {
					url: `/settings/vehicle-perspectives`,
					method: "GET",
					types: [
						GET_VEHICLE_PERSPECTIVES,
						GET_VEHICLE_PERSPECTIVES_SUCCESS,
						GET_VEHICLE_PERSPECTIVES_FAILED,
					],
					showLoader: true,
					showToast: true,
					params,
				},
			});
		} catch (error) {
			// alert("W66 = " + `${error}`);
			console.error("WShop - 68", error);
		}
	};

export const getDamageTypes =
	(params = {}) =>
	async (dispatch) => {
		try {
			return await dispatch({
				[CALL_API]: {
					url: `/settings/damage-types`,
					method: "GET",
					types: [GET_DAMAGE_TYPES, GET_DAMAGE_TYPES_SUCCESS, GET_DAMAGE_TYPES_FAILED],
					showLoader: true,
					showToast: true,
					params,
				},
			});
		} catch (error) {
			// alert("W85 = " + `${error}`);
			console.error("WShop - 88", error);
		}
	};

export const getBodyDamageTypes =
	(params = {}) =>
	async (dispatch) => {
		try {
			return await dispatch({
				[CALL_API]: {
					url: `/catalog/services/body-damage`,
					method: "GET",
					types: [
						GET_BODY_DAMAGE_TYPES,
						GET_BODY_DAMAGE_TYPES_SUCCESS,
						GET_BODY_DAMAGE_TYPES_FAILED,
					],
					showLoader: true,
					showToast: true,
					params,
				},
			});
		} catch (error) {
			// alert("W108 = " + `${error}`);
			console.error("WShop - 112", error);
		}
	};

// export const globalSettings = () => async (dispatch) => {
//   try {
//     return await dispatch({
//       [CALL_API]: {
//         url: `/settings/global-settings`,
//         method: "GET",
//         types: [GET_GLOBAL_SETTINGS, GET_GLOBAL_SETTINGS_SUCCESS, GET_GLOBAL_SETTINGS_FAILED],
//         showLoader: true,
//       },
//     });
//   } catch (error) {
//     // alert("W123 = " + `${error}`);
//     console.error("WShop - 128", error);
//   }
// };

export const getListOfWorkshops =
	(params = {}) =>
	async (dispatch) => {
		try {
			return await dispatch({
				[CALL_API]: {
					url: `/catalog/workshops`,
					method: "GET",
					types: [
						GET_LIST_OF_WORKSHOPS,
						GET_LIST_OF_WORKSHOPS_SUCCESS,
						GET_LIST_OF_WORKSHOPS_FAILED,
					],
					showLoader: true,
					params,
				},
			});
		} catch (error) {
			// alert("W145= " + `${error}`);
			console.error("WShop - 151", error);
		}
	};

// export const getWorkshopsDistance =
//   (params = {}) =>
//   async (dispatch) => {
//     try {
//       return await dispatch({
//         [CALL_API]: {
//           url: `maps/api/directions/json`,
//           method: "GET",
//           types: [
//             GET_WORKSHOP_DISTANCE,
//             GET_WORKSHOPS_DISTANCE_SUCCESS,
//             GET_WORKSHOPS_DISTANCE_FAILED,
//           ],
//           showLoader: true,
//           params,
//         },
//       });
//     } catch (error) {
//       alert("W167 = " + `${error}`);
//     }
//   };

export const clearDamageTypes = () => {
	return {
		type: CLEAR_DAMAGE_TYPES,
	};
};

export const clearBodyDamageTypes = () => {
	return {
		type: CLEAR_BODY_DAMAGE_TYPES_SUCCESS,
	};
};

export const saveSelectedPartDetails = (id) => {
	return {
		data: id,
		type: SAVE_SELECTED_PART_ID,
	};
};

export const saveOrientationOfVehicle = (payload) => {
	return {
		data: payload,
		type: SAVE_ORIENTATION,
	};
};

export function logout() {
	return {
		type: LOGOUT_SUCCESS,
	};
}
